function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import CustomThemeSection from "../../../custom-theme-section/CustomThemeSection";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
const THEME_OVERRIDE = {
  palette: {
    dialogues: {
      expert: {
        text: "#002663",
        background: "rgba(0, 167, 157, .5)"
      }
    }
  }
};
const useStyles = makeStyles(theme => ({
  modelAnswerContainer: {
    display: "flex",
    marginTop: 8,
    justifyContent: "flex-end"
  },
  modelAnswer: {
    lineHeight: 0.8,
    fontSize: "0.625rem"
  },
  bodyText: {
    color: theme.palette.background.white
  }
}));
const ModelAnswerDialogue = ({
  dialogue,
  ...rest
}) => {
  const {
    body,
    type
  } = dialogue;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(CustomThemeSection, {
    themeOverrides: THEME_OVERRIDE
  }, /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: false,
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    body: body,
    classes: {
      bodyText: classes.bodyText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.modelAnswerContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary",
    className: classes.modelAnswer
  }, type === "reminder" ? "System" : "Model Answer")))));
};
export default ModelAnswerDialogue;
ModelAnswerDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired
};